"use strict";
import mediumStyles from "../src/express/scale-medium.css.js";
import { Theme } from "../src/Theme.dev.js";
import "../src/express/core.dev.js";
Theme.registerThemeFragment("medium-express", "scale", mediumStyles);
//# sourceMappingURL=scale-medium.dev.js.map
